// extracted by mini-css-extract-plugin
module.exports = {"accordionWrapper":"_b0d6554","cardGroup":"_f45e817"};